module.exports = __webpack_public_path__ + "static/wechat-code-4335b047c1962b259354ec64c5621c66.png";